import { GLYPH_ICONS } from 'shared/glyphIcons';

export const ICONS = GLYPH_ICONS;
